import { addToQueryParameters } from '@/utility'

export const handleQueryParams = store => {
  store.subscribe(mutation => {
    if (mutation.type.split('/')[0] === 'queryParams') {
      addToQueryParameters()
    }
  })
}
